<template>
  <div id="points">
    <div class="discover">
      
    </div>
    <ul class="list">
      <li class="point" :class="{'active' : current.slug === project.slug}" v-for="(project, i) in projects" :key="i"></li>
    </ul>
  </div>
</template>

<script>

import projects from '@/json/projects'

export default {
  name: 'NavPoints',
  props: {
    current: {
      type: Object,
      required: true
    }
  },
  data(){
    return{
      projects,
    }
  }
}
</script>

<style lang="scss">
  #points{
    position: fixed;
    z-index: 110;
    bottom: var(--body-padding);
    right: var(--body-padding);
    .list {
      list-style: none;
      display: flex;
      flex-direction: row;
    }
    .point{
      width: 8px;
      height: 4px;
      background-color: var(--light-grey);
      margin-left: 6px;
      transition: background-color .1s var(--easing);
      &.active{
        background-color: var(--primary);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NavPoints.vue